import dayjs from 'dayjs'

import { Button } from 'core-components/library/button'
import { IColumn } from 'core-components/library/list/types'

import { TRANSLATION_KEYS } from '../../../../../translations'
import { IQbrAttachment } from '../../../models/qbrAttachment'
import styles from '../AttachmentsTable.module.scss'

interface IGetColumnsParameters {
  deleteAttachment: (attachment: IQbrAttachment) => void
  downloadAttachment: (attachment: IQbrAttachment) => void
}

export const getColumns = ({
  deleteAttachment,
  downloadAttachment,
}: IGetColumnsParameters): IColumn<IQbrAttachment>[] => {
  return [
    {
      title: TRANSLATION_KEYS.qbrAttachments.attachmentsColumns.fileName,
      field: 'Name',
      priority: 1,
      hideSettings: true,
      disableSort: true,
    },
    {
      title: TRANSLATION_KEYS.qbrAttachments.attachmentsColumns.uploadDate,
      field: 'Created',
      priority: 2,
      hideSettings: true,
      renderFunction: (item) => {
        const date = new Date(item.Created)
        return <div>{dayjs(date).format('DD/MM/YYYY')}</div>
      },
    },
    {
      title: TRANSLATION_KEYS.qbrAttachments.attachmentsColumns.creator,
      field: 'CreatedBy',
      priority: 3,
      hideSettings: true,
      disableSort: true,
    },
    {
      title: '',
      field: '',
      priority: 4,
      hideSettings: true,
      disableSort: true,
      width: 100,
      renderFunction: (item) => {
        return (
          <>
            <Button
              onClick={() => downloadAttachment(item)}
              iconButton="kbase kbase-lvl-download-circle"
            />
            <Button
              color="danger"
              className={styles.deleteButton}
              iconButton="kbase kbase-delete"
              onClick={() => deleteAttachment(item)}
            />
          </>
        )
      },
    },
  ]
}
